import { useEffect, useState } from "react";
import AllAppointmentList from "../Tables/AllAppointmentList";
import ActiveAppointmentList from "../Tables/ActiveAppointmentList";
import HistoryAppointmentList from "../Tables/HistoryAppointmentList";
import UpcomingAppointmentList from "../Tables/UpcomingAppointmentList";

import { FiSearch, FiFilter, FiDownload, FiUser } from "react-icons/fi";
import AppointmentFilterPopover from "../Appointments/AppointmentFilter";
import { useLazyGetalldocappointmentsQuery } from "../../../State/Api/AdddocApiSlice";
import ClinicsideAppointmentfilters from "../../ClinicsideAppointmentfilters";
import DefaultPatientFilters from "../../ClinicComponent/Filters/DefaultPatientFilters";
import DoctorAppointmentViewFilters from "../../ClinicComponent/Filters/ClinicFilterJSON/DoctorAppointmentsView";


const AppointmentTabs = ({  getAppointments,
  isFetching,
  isLoading,
  isSuccess,
  gridRef,
  selectedFilters,
hasData,
  setHasData}) => {
  const [activeTab, setActiveTab] = useState("allappointments");

    const [patientDetail, setPatientDetail] = useState("");

  

  
  // const [fetchAppointments, { data: appointmentData = [], isFetching }] =
  //   useLazyGetalldocappointmentsQuery();

  // useEffect(() => {
  //   if (clinicUserId && doctorUserUniqueID) {
  //     fetchAppointments({ clinicUserId, doctorUserUniqueID });
  //   }
  // }, [clinicUserId, doctorUserUniqueID]);

  const tabButtonStyle = (key) =>
    `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${
      activeTab === key
        ? "bg-white text-black shadow-sm"
        : "text-muted-foreground hover:text-black"
    }`;

  return (
    <div className="space-y-4" style={{ height: "100%", width: "100%" }}>

      {/* Tab Content */}
      <div className="p-2 border rounded-lg bg-white shadow-sm mb-5" style={{height:'100%'}}>

          <AllAppointmentList     
          getAppointments={getAppointments}
                isFetching={isFetching}
                isLoading={isLoading}
                isSuccess={isSuccess}
                gridRef={gridRef}
                selectedFilters={selectedFilters}
                hasData={hasData}          
                setHasData={setHasData}  />

        
      </div>
    </div>
  );
};

export default AppointmentTabs;
